import { BaSeParagraph } from '@base/react';
import styled from 'styled-components';
import btAccess from '../assets/button-home.png';

export const ContainerHome = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-y: auto;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const ButtonAccess = styled.div`
  background: url(${btAccess});
  cursor: pointer;
  width: 223px;
  height: 40px;

  &:hover {
    box-shadow: 0px 0px 5px 0px #ff1493;
  }
`;

export const TextBlock = styled.div`
  margin-left: auto;
  flex: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    margin-left: 0;
    text-align: center;
    width: 100%;
  }
`;

export const InfoText = styled.div`
  max-width: 420px;
`;

export const TextAccess = styled.div`
  padding-bottom: 20px;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LinkAqui = styled(BaSeParagraph)`
  cursor: pointer;
  color: #fff;
  text-decoration: underline;
`;

export const WrapperLink = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 16px;
  }
`;

export const GradientContainer = styled.div`
  flex: 1;
  background: linear-gradient(
    to right,
    ${({ primary }) => primary} 0% 60%,
    ${({ secondary }) => secondary} 60% 85%,
    ${({ tertiary }) => tertiary} 85% 100%
  );
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media (max-width: 768px) {
    background: linear-gradient(
      to bottom,
      ${({ primary }) => primary} 0% 70%,
      ${({ secondary }) => secondary} 70% 85%,
      ${({ tertiary }) => tertiary} 85% 100%
    );
    align-items: flex-end;
  }
`;
export const ContentHero = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-shrink: 0;
  max-width: 55%;

  img {
    width: 90%;
    max-height: 80vh;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 768px) {
    max-width: 65%;
    margin-bottom: 0;
    padding-bottom: 0;

    img {
      max-height: 50vh;
    }
  }

  @media (max-width: 425px) {
    max-width: 75%;

    img {
      max-height: 35vh;
    }
  }
`;

export const Description = styled.p`
  font-family: 'Inter', sans-serif;
  color: #fff;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ContentTitle = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  height: 120px;

  img {
    transform: scale(0.6);
    flex-shrink: 0;
  }

  @media (max-width: 425px) {
    justify-content: center;
    img {
      display: none;
    }
    p {
      font-size: 36px;
    }
  }
`;

export const ContentAuth = styled.div`
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Title = styled.p`
  font-family: 'Inter', sans-serif;
  color: #fff;
  font-size: 2em;
  font-style: normal;
  font-weight: 200;
  line-height: 48px;

  @media (max-width: 375px) {
    font-size: 2em;
    line-height: 38px;
  }
`;
